module.exports = __webpack_public_path__ + "fontawesome-webfont.acf3dcb7ff752b5296ca.svg";


//////////////////
// WEBPACK FOOTER
// D:/taile-operate/BLACK-WIDOW/ng-src/assets/font-awesome/fonts/fontawesome-webfont.svg?v=4.7.0
// module id = ../../../../../ng-src/assets/font-awesome/fonts/fontawesome-webfont.svg?v=4.7.0
// module chunks = styles